<script lang="ts">
	import AvatarComponent from '$lib/shared/ui/AvatarComponent.svelte';
	import PopupAccountBox from '$lib/features/user/ui/PopupAccountBox.svelte';
	import Copyright from '$lib/shared/ui/Copyright.svelte';
	import Legal from '$lib/shared/ui/Legal.svelte';
	import CrownLeaderboardLink from '$lib/shared/ui/CrownLeaderboardLink.svelte';
	import ThemeToggle from '$components/ThemeToggle.svelte';
	import type { User } from '$lib/shared/lib/types';

	interface Props {
		user: User | null;
		children?: import('svelte').Snippet;
	}

	let { user, children }: Props = $props();

	const lightLeft = '/static/images/light-left.avif';
	const lightRight = '/static/images/light-right.avif';
</script>

<div class="relative flex min-h-dvh flex-col">
	<!-- Decorative Images -->
	<div class="pointer-events-none absolute top-0 left-0 z-0 h-1/5 w-1/5">
		<img src={lightLeft} alt="" class="" draggable="false" />
	</div>
	<div class="pointer-events-none absolute top-0 right-0 z-0 h-1/5 w-1/5">
		<img src={lightRight} alt="" class="" draggable="false" />
	</div>

	<header class="absolute top-0 right-0 z-20 p-4">
		<div class="flex items-center justify-end gap-3">
			<ThemeToggle />
			<AvatarComponent logged={!!user} src={user?.avatar}>
				<PopupAccountBox {user} />
			</AvatarComponent>
		</div>
	</header>

	<main class="relative z-10 flex-1">
		{@render children?.()}
	</main>

	<footer class="container m-auto">
		<div class="flex flex-col items-center space-y-1 py-4">
			<CrownLeaderboardLink />
			<Legal />
			<Copyright />
		</div>
	</footer>
</div>
